// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__+MR0B","footer":"footer_footer__sl-OP","text":"footer_text__Ct-WR"};